import React from 'react';

import { useMapStateStore } from '../../../../stores';

import RoadmapIcon from './RoadmapIcon';
import HybridIcon from './HybridIcon';

import '../MapControls.scss';

const MapControlsToggle = () => {
  const activeMapType = useMapStateStore((state) => state.activeMapType);
  const setActiveMapType = useMapStateStore((state) => state.setActiveMapType);

  let roadmapClass = '';
  let hybridClass = '';
  if ( activeMapType === 'roadmap' ) {
    // the roadmap is active, so show the hybrid map button
    hybridClass = 'mapControlToggle-toggleOption--show';
  }
  if ( activeMapType === 'hybrid' ) {
    // the hybrid map is active, so show the roadmap button
    roadmapClass = 'mapControlToggle-toggleOption--show';
  }

  return (
    <div className="mapControlToggle mapControlToggle--mapType">
      <button
        type="button"
        className={`mapControlToggle-toggleOption ${roadmapClass}`}
        onClick={(e) => {
          e.currentTarget.blur();
          setActiveMapType( 'roadmap' );
        }}
      >
        <RoadmapIcon />
      </button>

      <button
        type="button"
        className={`mapControlToggle-toggleOption ${hybridClass}`}
        onClick={(e) => {
          e.currentTarget.blur();
          setActiveMapType( 'hybrid' );
        }}
      >
        <HybridIcon />
      </button>

    </div>
  );
};

export default MapControlsToggle;
